import Big from 'big.js';
import { z } from 'zod';

export const zIsNumber = () =>
  z.union([z.string(), z.number()]).transform((v, ctx) => {
    try {
      return new Big(v).toFixed();
    } catch {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Invalid value. Must be a number.',
      });
      return z.NEVER;
    }
  });
